import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';

import { routes } from './app-routing.module';

// not used in production
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { dataFeedreducer } from './data-feeds/reducers/data-feed.reducer';
import { mobilityHubReducer } from './mobility-hubs';
import { noParkingZoneReducer } from './no-parking-zones';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        StoreModule.forRoot({
            dataFeeds: dataFeedreducer,
            mobilityHubs: mobilityHubReducer,
            noParkingZones: noParkingZoneReducer,
            router: routerReducer
        }),
        RouterModule.forRoot(routes),
        StoreRouterConnectingModule.forRoot(),
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument()
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {}
